module.exports = __webpack_public_path__ + "static/media/email-opened.2f3ccad9.svg";